<template>
  <v-autocomplete
    autocomplete="off"
    dense
    label="Module"
    outlined
    placeholder="Select..."
    v-model="module"
    :disabled="disabled"
    :rules="rules"
    :items="modules"
    @change="$emit('update:module', module);"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'ProductModuleSelect',
  data() {
    return {
      // module: { module_name: 'cpanel', id: 2 },
      modules: [
        { text: 'manual', value: { module_name: 'manual', id: 1 } },
        { text: 'cPanel', value: { module_name: 'cpanel', id: 2 } },
      ],
    };
  },
  mounted() {
    this.$emit('update:module', this.module);
  },
  props: {
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    module: {
      type: Object,
      default() {
        return { module_name: 'cpanel', id: 2 };
      },
    },
  },
};
</script>

<style scoped>

</style>
